// import Cookies from "@/plugins/cookie";
import config from "@/config";
import Cookies from "js-cookie";
import Vue from "vue";
import store from "@/store";
import md5 from 'js-md5';

/*获取getGlobalUserId*/
export function getGlobalUserId() {
    if (Cookies.get('globalUserId')) {
        return Cookies.get('globalUserId')
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    uuid = uuid.replace(/-/g, '');
    Cookies.set('globalUserId', uuid, { expires: 365 });
    return uuid
}

export function getGlobalUserIdImgCode() {
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    uuid = uuid.replace(/-/g, '');
    Cookies.set('globalUserId', uuid, { expires: 365 });
    return uuid
}

/*获取地址栏参数*/
export function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

/*添加或者更新uri中的参数*/
export function updateParam(key, value, uri) {

    // Use window URL if no query string is provided
    if (!uri) {
        uri = window.location.href;
    }

    // Create a dummy element to parse the URI with
    var a = document.createElement('a'),

        // match the key, optional square bracktes, an equals sign or end of string, the optional value
        reg_ex = new RegExp(key + '((?:\\[[^\\]]*\\])?)(=|$)(.*)'),

        // Setup some additional variables
        qs,
        qs_len,
        key_found = false;

    // Use the JS API to parse the URI
    a.href = uri;

    // If the URI doesn't have a query string, add it and return
    if (!a.search) {

        a.search = '?' + key + '=' + value;

        return a.href;
    }

    // Split the query string by ampersands
    qs = a.search.replace(/^\?/, '').split(/&(?:amp;)?/);
    qs_len = qs.length;

    // Loop through each query string part
    while (qs_len > 0) {

        qs_len--;

        // Check if the current part matches our key
        if (reg_ex.test(qs[qs_len])) {

            // Replace the current value
            qs[qs_len] = qs[qs_len].replace(reg_ex, key + '$1') + '=' + value;

            key_found = true;
        }
    }

    // If we haven't replaced any occurences above, add the new parameter and value
    if (!key_found) {
        qs.push(key + '=' + value);
    }

    // Set the new query string
    a.search = '?' + qs.join('&');

    return a.href;
}

/*是否是微信浏览器*/
export function isWechatBrowser() {
    return window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
}

/**
 * 获取时间
 * @method getTime
 * @param
 */
export function getTime() {
    // return Math.round((new Date().getTime() - localStorage.getItem('ec_time')) / 1000, 10);
    // return Math.round((new Date().getTime() - window.ec_time) / 1000, 10);
    if(window.ec_time_request){
        return Math.round(new Date().getTime() / 1000, 10) - window.ec_time;
    }else{
        return Math.round(new Date().getTime() / 1000, 10);
    }
    
}
// 获取日期时间戳
export function getTimestampIos(date) {
    var date = date ? new Date(date.substr(0, 10)).getTime() : new Date().getTime()
    return Math.round(date / 1000)
}

//日期时间格式化
export function formatDateTime(dt, fmt) {
    let o = {
        "M+": dt.getMonth() + 1,                 //月份
        "d+": dt.getDate(),                    //日
        "h+": dt.getHours(),                   //小时
        "m+": dt.getMinutes(),                 //分
        "s+": dt.getSeconds(),                 //秒
        "q+": Math.floor((dt.getMonth() + 3) / 3), //季度
        "S": dt.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (dt.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

// 获取日期时间戳
export function getTimestamp(date) {
    date = new Date(date.replace(/-/g,'\/'));
    date = date.getTime();
    return Math.round(date / 1000)
}

// 时间戳转时间
export function timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
}

// 时间戳转时间时分 10:00
export function timestampToHours(timestamp) {
  var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  return h + m
}

// 时间戳转年份
export function timestampToYear(timestamp) {
    var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    return date.getFullYear();
}

// 时间戳转月份
export function timestampToMonth(timestamp) {
    var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    return (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
}

// 时间戳转日
export function timestampToDay(timestamp) {
    var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    return (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
}

//毫秒数转时分秒
export function getDuration(my_time) {
    var days = my_time / 1000 / 60 / 60 / 24;
    var daysRound = Math.floor(days);
    var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
    var hoursRound = Math.floor(hours);
    var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
    var allMinutes = my_time / 1000 / 60 - (24 * 60 * daysRound);
    var minutesRound = Math.floor(minutes);
    var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
    var time = [daysRound, hoursRound, minutesRound]
    return allMinutes;
}

// 时分秒转 时分AM
export function HourMinuteToStr(str) {
    var hour = str.substring(0, 2);
    var out = str.substring(0, 5);
    var str = hour > 12 ? 'PM' : 'AM';
    return out + str;
}

export function htmlEncodeByRegExp(str) {
    var s = "";
    if (str.length == 0) return "";
    s = str.replace(/</g, "");
    s = s.replace(/>/g, "");
    s = s.replace(/\'/g, "");
    s = s.replace(/\"/g, "");
    s = s.replace(/javascript/g, "");
    s = s.replace(/alert/g, "");
    return s;
}

// 数组排序
export function sortKey(array, key) {
    return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x < y ? 1 : 0;
    });
}

// 数组按汉字首字母排序
export function cnWordSort(array, key){
    // return array.sort(function (a, b) {
    //   return a[key].localeCompare(b[key]);
    // });
    let zhArr = [],
        enArr = [],
        regex = /[a-zA-Z]/;

    array.map((item, index)=>{
        if(item[key].length > 0){
            if(regex.test(item[key][0])){
                enArr.push(item);
            }else{
                zhArr.push(item);
            }
        }
    });
    zhArr = zhArr.sort(function(a,b){
        return a[key].localeCompare(b[key], 'zh-Hans-CN', {sensitivity: 'accent'})
    });
    enArr = enArr.sort(function(a,b){
        return a[key].localeCompare(b[key], 'zh-Hans-CN', {sensitivity: 'accent'})
    });
    return zhArr.concat(enArr);
}

export function objectToString(obj){
    // return Object.entries(obj).reduce((arr, [k, v]) => arr.concat(encodeURIComponent(k) + '=' + encodeURIComponent(v)), []).join('&');
    // return new URLSearchParams(obj).toString();
    let str = '';
    let i = 0;
    for(let key in obj){
        if(i == 0){
            str += key + '=' + obj[key];
        }else{
            str += '&' + key + '=' + obj[key];
        }
        i++;
    }
    return str;
}

export function delUrlParams(...name){
    let url = window.location.href;
    let temp = url.split("?");
    if(temp.length > 1){
        let params = url.split("?")[1].split("&");
        let obj = {};
        params.map(item => obj[item.split("=")[0]] = item.split("=")[1]);
        let newParams = {};
        for(let key in obj){
            if(name.indexOf(key.toString()) == -1){
                newParams[key] = obj[key];
            }
        }
        let newUrl = temp[0];
        if(newParams){
            let newParamsUrl = new URLSearchParams(newParams).toString();
            newUrl = temp[0] + '?' + newParamsUrl;
        }
        newUrl = newUrl.replace('?=undefined', '');
        location.replace(newUrl);
    }
    else{
        return true;
    }
}

export function getRedirectUrl(type, params){
    let url = '';
    let from = ''
    if (type == 'login') {
        url = config.oceanengine.loginByMobileUrl;
    } else if (type == 'register') {
        url = config.oceanengine.registerByMobileUrl;
    } else if (type == 'logout') {
        url = config.oceanengine.logoutUrl;
    } else {
        console.error('# Return current href. "getRedirectUrl()" require correct param: "type"')
        return window.location.href
    }
    from = window.location.href.split("?")[0];
    if (type == 'logout') {
        from = window.location.href.split('#')[0];
    }
    if(params){
        from += '?';
        from += new URLSearchParams(params).toString();
    }
    return url + encodeURIComponent(from);
}

export function getMyUrl(){
    let url = window.location.href;
    return url.split('?')[0];
}

export function checkIdCard(str){
    // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if(!format.test(str)){
        return false;
    }
    //区位码校验
    //出生年月日校验  前正则限制起始年份为1900;
    var year = str.substr(6,4),//身份证年
        month = str.substr(10,2),//身份证月
        date = str.substr(12,2),//身份证日
        time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
        now_time = Date.parse(new Date()),//当前时间戳
        dates = (new Date(year,month,0)).getDate();//身份证当月天数
    if(time>now_time||date>dates){
        return false;
    }
    //校验码判断
    var c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);  //系数
    var b = new Array('1','0','X','9','8','7','6','5','4','3','2'); //校验码对照表
    var id_array = str.split("");
    var sum = 0;
    for(var k=0;k<17;k++){
        sum+=parseInt(id_array[k])*parseInt(c[k]);
    }
    if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
        return false;
    }
    return true;
  }

  // Set element scrollable
  export function setElementScrollable(querySelectorStr, scrollable, drection) {
    let styleName = 'overflow'
    if (drection === 'x') styleName += '-x';
    if (drection === 'y') styleName += '-y';
    document.querySelector(querySelectorStr).style[styleName] = scrollable ? '' : 'hidden'
  }

export function maskNickname(str) {
  if (str == '游客') {
    return '游客';
  }
  if (str.length == 1) {
    return str + '*';
  } else if (str.length == 2) {
    return str.substr(0, 1) + '*';
  } else if (str.length == 3) {
    return str.substr(0, 1) + '*' + str.substr(2, 1);
  } else if (str.length > 3) {
    return str.substr(0, 1) + '*' + str.substr(-1);
  } else if (str.length == 0) {
    return '游客';
  }
}

// 校验合法url
export function verifyUrl(str) {
  str = str.toString();
  if(str.indexOf('javascript:') != -1){
    return false;
  }else{
    if(str.match(/(http|https):\/\/([\w.]+\/?)\S*/ig)){
      return Vue.prototype.$xss(str);
    }else{
      return false;
    }
  }
}

// 嘉宾列表处理
export function guestListDataCook(res) {
    let data = [];
    if(res.result == 0){
        let guestNameArr = [],
            guestAgendaIdArr = [];
        for(let key in res.content){
            if(guestNameArr.indexOf(res.content[key].guestInfo.name) == -1){
            // if(res.content[key].guestInfo.isRecommendHome == '1'){

                let temp = res.content[key].guestInfo;
                temp.guestId = key;
                temp.guestsOrder = temp.guestsOrder * 1;
                temp.seminarList = [];
                temp.seminarNames = '';
                let seminarNameArr = [];
                res.content[key].seminarList.map(item=>{
                    // if(item.category == '主题演讲'){
                        temp.seminarList.push(item);
                        seminarNameArr.push(item.name);
                        guestAgendaIdArr.push(temp.name + '^' + item.name);
                    // }
                });
                temp.seminarNames = seminarNameArr.join('^');
                // temp.coverImageUrl = process.env.VUE_APP_FLAG === 'pro' ? 'https://hwyhw.smarket.net.cn/content/index.php?mappingId=' : 'https://hwuat.smarket.net.cn/content/index.php?mappingId=';
                // temp.coverImageUrl += temp.imageMapId;
                temp.realPath = replaceCdnUrl(temp.realPath);
                temp.seoWords = temp.name + '^' + temp.duty;
                data.push(temp);
                guestNameArr.push(temp.name);
            // }
            }else{
                if(res.content[key].seminarList && res.content[key].seminarList.length > 0){
                    let index = -1;
                    data.map((dataItem, dataIndex)=>{
                        if(dataItem.name == res.content[key].guestInfo.name){
                            index = dataIndex;
                        }
                    });
                    
                    if(index != -1){
                        res.content[key].seminarList.map(agendaItem=>{
                            if(guestAgendaIdArr.indexOf(res.content[key].guestInfo.name + '^' + agendaItem.name) == -1){
                                data[index].seminarList.push(agendaItem);
                            }
                        });
                    }
                }
            }

            data.map(orderItem=>{
                orderItem.seminarList = sortKey(orderItem.seminarList, 'startTime').reverse();
            });

        }
        data = cnWordSort(data, 'name');
        data = sortKey(data, 'guestsOrder');
    }
    return data;
}

// 文章列表处理
export function articleListDataCook(res) {
    let data = {};
    if(res.result == 0){
        res.content.items.map(item=>{
            item.coverImageRealPath = replaceCdnUrl(item.coverImageRealPath);
        });
        data = sortKey(res.content.items, 'order');
    }
    return data;
}

// 精彩图集处理
export function wonderfulPicDataCook(res) {
    let data = {
        firstImg: '',
        list: [],
        list2: [],
    };
    if(res.result == 0){
        let temp = [];
        res.content.items.map(item=>{
            item.coverImageRealPath = replaceCdnUrl(item.coverImageRealPath);
            if(item.isTop == 1){
                data.firstImg = item.coverImageRealPath;
            }else{
                temp.push(item);
            }
        });
        temp = sortKey(temp, 'order');
        temp.map((item, index)=>{
            if(index%2 == 0){
                data.list.push(item.coverImageRealPath);
            }else{
                data.list2.push(item.coverImageRealPath);
            }
        });
    }
    return data;
}

// 大咖观点处理
export function wonderfulWordsDataCook(res) {
    let data = [];
    if(res.result == 0){
        res.content.items.map(item=>{
            item.coverImageRealPath = replaceCdnUrl(item.coverImageRealPath);
            item.guestName = '';
            item.guestDuty = '';
            let temp = item.title.split('^');
            if(temp.length == 1){
                item.guestName = temp[0];
            }else if(temp.length == 2){
                item.guestName = temp[0];
                item.guestDuty = temp[1];
            }
            // item.summary = item.summary.split('').join(' ');
        });
        data = sortKey(res.content.items, 'order');
    }
    return data;
}

// 赞助商列表处理
export function partnerChildListDataCook(res) {
    let data = {};
    if(res.result == 0){
        res.content.items.map(item=>{
            item.coverImageRealPath = replaceCdnUrl(item.coverImageRealPath);

            item.sponsor_type = '';
            let temp = item.title.split('^');

            item.title = temp[0];
            if(temp.length == 2){
                item.sponsor_type = temp[1];
            }
        });
        data = sortKey(res.content.items, 'order');
    }
    return data;
}

// 热门资讯列表处理
export function hotNewsListDataCook(res) {
    let data = {};
    if(res.result == 0){
        res.content.items.map(item=>{
            item.coverImageRealPath = replaceCdnUrl(item.coverImageRealPath);

            item.product_tag = '';
            item.industry_tag = '';
            let temp = item.summary.split('{^}');

            item.summary = temp[0];
            if(temp.length == 2){
                item.product_tag = temp[1];
            }else if(temp.length == 3){
                item.product_tag = temp[1];
                item.industry_tag = temp[2];
            }
        });
        data = sortKey(res.content.items, 'order');
    }
    return data;
}
// 展厅数据列表处理
export function extHallDataCook(res) {
    let data = [];
    if(res.result == 0){
        res.content.items.map(item=>{
            item.m_industry_tag_arr = [];
            item.m_industry_tag = '';
            item.m_product_tag_arr = [];
            item.m_product_tag = '';

            if(item.tags){
                item.tags.map(tagItem=>{
                    if(tagItem.displayName == '展厅分类(2021华为生态伙伴大会小程序专用)'){
                        if(tagItem.name.indexOf('行业$') != -1){
                            item.m_industry_tag_arr.push(tagItem.name.split('$')[1].replace('^', '-'));
                        }
                        if(tagItem.name.indexOf('产品$') != -1){
                            item.m_product_tag_arr.push(tagItem.name.split('$')[1].replace('^', '-'));
                        }
                        item.m_industry_tag = item.m_industry_tag_arr.join('^');
                        item.m_product_tag = item.m_product_tag_arr.join('^');
                    }
                });
            }


            item.subCategories.map(childItem=>{
                childItem.coverImageRealPath = replaceCdnUrl(childItem.coverImageRealPath);
                childItem.seoWords = childItem.title;
                let temp = childItem.summary.split('^');
                childItem.folderId = temp[0];
                childItem.summary = temp[1];
            });
            data.push({
                cateName: item.title,
                cateId: item.articleCategoryId,
                child: item.subCategories,
                detail: item,
                m_industry_tag: item.m_industry_tag,
                m_product_tag: item.m_product_tag,
            });
        });
    }
    return data;
}

// 展厅数据列表处理-并行三组
export function extHallTriDataCook(res) {
    let data = [
        {
            cateName: '生态馆',
            cateId: config.reviewArticleCategory.exhibitionShengtai,
            child: [],
            detail: {}
        },
        {
            cateName: '产业馆',
            cateId: config.reviewArticleCategory.exhibitionChanye,
            child: [],
            detail: {}
        },
        {
            cateName: '行业馆',
            cateId: config.reviewArticleCategory.exhibitionHangye,
            child: [],
            detail: {}
        },
    ];
    res.map((item, index)=>{
        if(item.result == 0){
            item.content.items.map(childItem=>{
                childItem.coverImageRealPath = replaceCdnUrl(childItem.coverImageRealPath);
                childItem.seoWords = childItem.title;
                let temp = childItem.summary.split('^');
                childItem.folderId = temp[0];
                childItem.summary = temp[1];
                childItem.m_tag = [];
                childItem.m_industry_tag_arr = [];
                childItem.m_industry_tag = '';
                childItem.m_product_tag_arr = [];
                childItem.m_product_tag = '';
                if(childItem.hasOwnProperty('tags') && childItem.tags){
                    childItem.tags.map(tagItem=>{
                        if(tagItem.displayName == '展厅分类(2021华为生态伙伴大会小程序专用)'){
                            childItem.m_tag.push(tagItem.name);

                            if(tagItem.name.indexOf('行业$') != -1){
                                childItem.m_industry_tag_arr.push(tagItem.name.split('$')[1].replace('^', '-'));
                            }
                            if(tagItem.name.indexOf('产品$') != -1){
                                childItem.m_product_tag_arr.push(tagItem.name.split('$')[1].replace('^', '-'));
                            }
                            childItem.m_industry_tag = childItem.m_industry_tag_arr.join('^');
                            childItem.m_product_tag = childItem.m_product_tag_arr.join('^');
                        }
                    });
                }
            });
        }
        data[index].child = item.content.items;
    });

    return data;
}

// 展厅详情处理
export function exthallDetailDataCook(res) {
    let data = {};
    let list = [];
    if(res.result == 0){
        res.content.items.map(item=>{
            item.coverImageRealPath = replaceCdnUrl(item.coverImageRealPath);
            if(item.isTop == 1){
                data = item;
            }else{
                list.push(item);
            }
        });
        data.partner = sortKey(list, 'order');
        data.fileIdsArr = data.fileIds.split('|');
        data.fileList = [];
        data.content = '';
        data.banner = [];
        data.fileFolderId = 0;
        data.tags = [];
        let temp = data.summary.split('^');
        data.fileFolderId = temp.shift();
        data.hotel = temp.pop();
        data.tags = temp;
    }
    return data;
}

// 展厅详情处理-step2
export function exthallDetailDataCookStepTwo(res, id) {
    if(res.result == 0){
        res.content.id = id;
        res.content.content2 = stripHtmlTags(res.content.content);
        res.content.showImagesRealPath.map(item=>{
            item = replaceCdnUrl(item);
        });
        store.commit('setExtHallChildDetailCache', res);
    }
    return res;
}

// 文件夹返回数据处理
export function fileFolderDataCook(res, idArr, folderId) {
    let temp = [], temp2 = [];
    if(res.result == 0){
        res.content.items.map(item=>{
            item.order = item.order * 1;
            store.commit('setFileListCache', item);
            if(idArr.indexOf(item.fileId) != -1){
                temp.push(item);
            }
            temp2.push(item);
        });
        temp = sortKey(temp, 'order');
        temp2 = sortKey(temp2, 'order');
        store.commit('setFolderMapCache', {key: folderId, value: temp2});
    }
    return idArr.length > 0 ? temp : temp2;
}

// 用户数据处理
export function userDataCook(res) {
    let temp = [];
    if(res.result == 0){
        let userData = {
            phone: '',
            email: '',
            username: '',
            lingkaren: '',
            lingkarenshoujihao: '',
            checkInStatus: res.content.checkInStatus,
        };
        res.content.items.map(item=>{
            if(item.fieldName == 'name'){
                userData.username = item.value;
            }else if(item.fieldName == 'mobile'){
                userData.phone = item.value;
            }else if(item.fieldName == 'email'){
                userData.email = item.value;
            }else if(item.fieldName == 'lingkaren'){
                userData.lingkaren = item.value;
            }else if(item.fieldName == 'lingkarenshoujihao'){
                userData.lingkarenshoujihao = item.value;
            }
        });
        store.commit('setUserData', userData);
    }
    return res;
}

// 直播分类数据处理
export function liveCateDataCook(res) {
    let dest = [];
    if(res.result == 0){
        res.content[config.liveCateDicId].map(item=>{
            dest.push({
                name: item.name,
                showList: 0,
                content: item.child[Object.keys(item.child)[0]]
            });
        });
    }
    // console.log('liveCateDataCook', dest);
    store.commit('setLiveCateCache', dest);
    return dest;
}

// 议程地址数据处理
export function agendaAddressDataCook(res) {
    if(res.result == 0){
        store.commit('setAgendaAddressCache', res.content.items);
        let filter = {
            name: '展厅',
            child: []
        };
        let filterName = [];
        res.content.items.map(item=>{
            if(filterName.indexOf(item.venue) == -1){
                filter.child.push({name: item.venue});
                filterName.push(item.venue);
            }
        });
        filter.child = sortKey(filter.child, 'name').reverse();
        store.commit('setAgendaAddressFilterCache', filter);
    }
    return res;
}

// 专题演讲数据查询
export function specialTopicFilesCook(res) {
    if(res.result == 0){
        store.commit('setSpecialFilesCache', res);
        let data = res.content.content;
        for(let key in data){
            data[key].map(item=>{
                store.commit('setFileListCache', item);
            });
        }
    }
    return true;
}

// 构造数组，num个元素一组
export function constructData(data, num = 3) {
    let point = 0,
        dest = [];
    for (let i = 0; i < data.length; i++) {
        if (i >= point * num && i < (point + 1) * num) {
            if (dest.length == point) {
                dest[point] = [data[i]];
            } else {
                dest[point].push(data[i]);
            }
        }
        if ((i + 1) % num == 0) {
            point++;
        }
    }
    return dest;
}

// 子议程列表处理
export function seminarListDataCook(res) {
    let seminarData = {};
    if(res.result == 0){
        let firstTopic = [],
            firstSpecial = [],
            firstOpen = [],
            secondTopic = [],
            secondSpecial = [],
            secondOpen = [],
            allAgenda = [];
        res.content.items.map(item=>{
            item.m_publish_val = 0;
            if(item.m_publish && item.m_publish.length>0){
                if(item.m_publish[0] == '1'){
                    item.m_publish_val = 1;
                }
            }

            if(item.m_publish_val == 1){
                if(item.startTime * 1 > 1621180800 && item.startTime * 1 < 1621267200){
                    item = agendaItemCook(item);
                    item.dayIndex = 0;
                    if(item.categoryArr.indexOf('主题演讲') != -1){
                        item.typeIndex = 0;
                        firstTopic.push(item);
                    }else if(item.categoryArr.indexOf('专题演讲') != -1){
                        item.typeIndex = 1;
                        firstSpecial.push(item);
                    }else if(item.categoryArr.indexOf('开放演讲') != -1){
                        item.typeIndex = 2;
                        if(firstOpen.length<50){
                            firstOpen.push(item);
                        }
                    }
                    allAgenda.push(item);
                }else if(item.startTime * 1 > 1621267200 && item.startTime * 1 < 1621353600){
                    item = agendaItemCook(item);
                    item.dayIndex = 1;
                    if(item.categoryArr.indexOf('主题演讲') != -1){
                        item.typeIndex = 0;
                        secondTopic.push(item);
                    }else if(item.categoryArr.indexOf('专题演讲') != -1){
                        item.typeIndex = 1;
                        secondSpecial.push(item);
                    }else if(item.categoryArr.indexOf('开放演讲') != -1){
                        item.typeIndex = 2;
                        if(secondOpen.length<50){
                            secondOpen.push(item);
                        }
                    }
                    allAgenda.push(item);
                }

                if(item.i_meetingLiveType && item.i_meetingLiveType.length == 2 && (item.i_meetingLiveType[1] == 'Σco·Live' || item.i_meetingLiveType[1] == '主题演讲')){
                    // console.log('setMainLiveAgendaCache 0', item);
                    if(isNumber(item.m_vhallLiveId) && item.i_liveurl){
                        store.commit('setMainLiveAgendaCache', item);
                    }
                }
            }

        });
        
        // 按开始时间排序
        firstTopic = sortKey(firstTopic, 'startTime').reverse();
        firstSpecial = sortKey(firstSpecial, 'startTime').reverse();
        firstOpen = sortKey(firstOpen, 'startTime').reverse();
        
        secondTopic = sortKey(secondTopic, 'startTime').reverse();
        secondSpecial = sortKey(secondSpecial, 'startTime').reverse();
        secondOpen = sortKey(secondOpen, 'startTime').reverse();

        // 二次排序 专题演讲
        firstSpecial = specialSortKey(firstSpecial);
        secondSpecial = specialSortKey(secondSpecial);

        // 三次排序 自定义字段
        firstTopic = sortKey(firstTopic, 'i_subSeminarOrder');
        firstSpecial = sortKey(firstSpecial, 'i_subSeminarOrder');
        firstOpen = sortKey(firstOpen, 'i_subSeminarOrder');
        
        secondTopic = sortKey(secondTopic, 'i_subSeminarOrder');
        secondSpecial = sortKey(secondSpecial, 'i_subSeminarOrder');
        secondOpen = sortKey(secondOpen, 'i_subSeminarOrder');
        
        
        

        firstOpen.map((item, index)=>{
            item.indexKey = index;
            item.index_zh = '话题' + numToZh(index+1);
            item.index_zh_img = require('@/assets/newImages/common/ht'+ (index+1) +'.png');
        });
        secondOpen.map((item, index)=>{
            item.indexKey = index;
            item.index_zh = '话题' + numToZh(index+1);
            item.index_zh_img = require('@/assets/newImages/common/ht'+ (index+1) +'.png');
        });

        firstSpecial.map((item, index)=>{
            item.indexKey = index;
        });
        secondSpecial.map((item, index)=>{
            item.indexKey = index;
        });

        firstTopic.map((item, index)=>{
            item.indexKey = index;
            if(item.agendaListData){
                item.agendaListData.map(childItem=>{
                    childItem.dayIndex = item.dayIndex;
                    childItem.typeIndex = item.typeIndex;
                });
            }
        });
        secondTopic.map((item, index)=>{
            item.indexKey = index;
            if(item.agendaListData){
                item.agendaListData.map(childItem=>{
                    childItem.dayIndex = item.dayIndex;
                    childItem.typeIndex = item.typeIndex;
                });
            }
        });

        store.commit('setAllAgendaCache', allAgenda);
        seminarData = {
            first: {
                topic: firstTopic,
                special: firstSpecial,
                open: firstOpen,
            },
            second: {
                topic: secondTopic,
                special: secondSpecial,
                open: secondOpen,
            },
        };
    }
    // console.log('seminarListDataCook', seminarData);
    return seminarData;
}

function specialSortKey(data){
    let before = [], after = [];
    data.map(item=>{
        if(item.timeIndex > 0){
            after.push(item);
        }else{
            before.push(item);
        }
    });
    after = sortKey(after, 'timeIndex');
    let ret = after.concat(before);
    return ret;
}

function agendaItemCook(item){
    item.startTimeStr = timestampToTime(item.startTime);
    item.startTime_h_m = item.startTimeStr.substr(11, 5);
    item.endTimeStr = timestampToTime(item.endTime);
    item.endTime_h_m = item.endTimeStr.substr(11, 5);
    item.startTime = item.startTime * 1;
    if(!item.i_subSeminarOrder){
        item.i_subSeminarOrder = 0;
    }else{
        item.i_subSeminarOrder = item.i_subSeminarOrder * 1;
    }

    

    if(isNumber(item.hotel)){
        let addressCache = store.state.cache.agendaAddress;
        let addressMatch = false;
        addressCache.map(addressItem=>{
            if(addressItem.id == item.hotel*1){
                item.hotel = addressItem.venue + ' ' + addressItem.meetingRoom;
                item.venue = addressItem.venue;
                addressMatch = true;
            }
        });
        if(!addressMatch){
            item.hotel = '';
        }
    }

    item.categoryArr = [];
    if(item.i_category && item.i_category.length > 0){
        if(item.i_category[0] == '主题演讲'){
            item.categoryArr = ['主题演讲'];
        }
    }

    if(item.categoryArr.length == 0){
        if(item.m_category && item.m_category.length > 0){
            if(item.m_category[0] == '峰会' || item.m_category[0] == '论坛' || item.m_category[0] == '微论坛'){
                item.categoryArr = ['专题演讲'];
            }else if(item.m_category[0] == '开放演讲'){
                item.categoryArr = ['开放演讲'];
            }
        }
    }

    item.isOrder = 0;
    if(store.state.myData.myOrderAgendaList.indexOf(item.subSeminarId) != -1){
        item.isOrder = 1;
    }

    item.zipNames = '';
    item.zipNamesArr = [];

    let agendaListData = [];
    let guest = [];
    let guestExist = [];
    let allGuestName = [];
    let allGuestExist = [];
    let filesArr = [];
    item.agendaList.map((sItem, sIndex) => {
        sItem.agendas.map((gItem, gIndex) => {
        let agendasArr = [];
        
        agendasArr.name = gItem.name;
        agendasArr.address = gItem.address;
        agendasArr.agendaId = gItem.agendaId;
        agendasArr.agendaDate = gItem.agendaDate;
        agendasArr.startTime = gItem.startTime;
        agendasArr.endTime = gItem.endTime;

        agendasArr.fileName = '';
        agendasArr.file = false;
        let fileCache = store.state.cache.fileList;
        fileCache.map(cacheItem=>{
            if(item.categoryArr[0] == '主题演讲' && cacheItem.fileId == gItem.remark && cacheItem.fileId != 0){
                agendasArr.file = cacheItem;
                item.zipNamesArr.push(cacheItem.name);
                agendasArr.fileName = cacheItem.name;
            }

            if(item.categoryArr[0] == '专题演讲' && cacheItem.agendaId && cacheItem.agendaId == gItem.agendaId && cacheItem.fileId != 0){
                agendasArr.file = cacheItem;
                item.zipNamesArr.push(cacheItem.name);
                agendasArr.fileName = cacheItem.name;
            }
        })

        if(gItem.remark){
            filesArr.push(gItem.remark);
        }
        
        agendasArr.agendaDateN = timestampToTime(agendasArr.agendaDate);
        agendasArr.startTimeN = timestampToTime(agendasArr.startTime);
        agendasArr.endTimeN = timestampToTime(agendasArr.endTime);
        
        agendasArr.startTime_h_m = agendasArr.startTimeN.substr(11, 5);
        agendasArr.endTime_h_m = agendasArr.endTimeN.substr(11, 5);

        let durStr = "";
        if (agendasArr.startTimeN && agendasArr.endTimeN) {
            durStr += agendasArr.startTimeN.substring(11, 5);
            durStr += "-";
            durStr += agendasArr.endTimeN.substring(11, 5);
            durStr += " ";
            durStr +=
            agendasArr.startTimeN.substring(11, 13) > 12 ? "PM" : "AM";
        }
        agendasArr.durStr = durStr;

        let nameArr = [];
        gItem.guests.map((ggItem, ggIndex) => {
            ggItem.name = trim(ggItem.name);
            nameArr.push(ggItem.name);
            if(Boolean(guestExist.indexOf(ggItem.demartmentEn+ggItem.nameEn)==-1)){
                guest.push(ggItem);
                guestExist.push(ggItem.demartmentEn+ggItem.nameEn);
            }
            if(allGuestExist.indexOf(ggItem.guestId) == -1){
                allGuestName.push(ggItem.name);
            }
            allGuestExist.push(ggItem.guestId);
            ggItem.fullDuty = ggItem.enterprise + ' ' + ggItem.duty.replace(' ', '<br/>');
        });

        agendasArr.guestNames = nameArr.join(',');
        agendasArr.guestName = gItem.guests.length > 0 ? gItem.guests[0].name : '';
        agendasArr.guestEnterprise = gItem.guests.length > 0 ? gItem.guests[0].enterprise : '';
        agendasArr.guestDemartment = gItem.guests.length > 0 ? gItem.guests[0].demartment : '';
        agendasArr.guestDuty = gItem.guests.length > 0 ? gItem.guests[0].duty : '';
        agendasArr.guestList = gItem.guests;

        agendaListData.push(agendasArr);
        });
    });

    item.zipNames = item.zipNamesArr.join('^');

    item.timeIndex = item.startTime * 1 - getTime();

    if(item.categoryArr[0] == '专题演讲' && item.timeIndex > 0){
        item.timeIndex = 30000000 - item.timeIndex;
    }

    item.m_tag_score = 0;
    item.m_tag_num = 0;
    item.m_industry_tag = '';
    item.m_product_tag = '';
    if(item.m_tag.length>0){
        item.m_tag_num = item.m_tag.length;

        let tempIn = [], tempPro = [];
        item.m_tag.map(tagItem=>{
            if(tagItem.indexOf('行业$') != -1){
                tempIn.push(tagItem.split('$')[1].replace('^', '-'));
            }
            if(tagItem.indexOf('产品$') != -1){
                tempPro.push(tagItem.split('$')[1].replace('^', '-'));
            }
            item.m_industry_tag = tempIn.join('^');
            item.m_product_tag = tempPro.join('^');
        });
    }

    agendaListData = sortKey(agendaListData, "startTime").reverse();

    agendaListData.map(richeng=>{
        richeng.p_zipNames = item.zipNames;
        richeng.p_name = item.name;
        richeng.p_m_industry_tag = item.m_industry_tag;
        richeng.p_m_product_tag = item.m_product_tag;
        richeng.p_type = item.categoryArr[0];
    });

    item.guestNames = allGuestName.join(',');
    item.agendaListData = agendaListData;
    item.guest = guest;
    item.firstGuest = agendaListData.length > 0 ? agendaListData[0].guestName : '';
    item.firstGuestEnterprise = agendaListData.length > 0 ? agendaListData[0].guestEnterprise : '';
    item.firstGuestDemartment = agendaListData.length > 0 ? agendaListData[0].guestDemartment : '';
    item.firstGuestDuty = agendaListData.length > 0 ? agendaListData[0].guestDuty : '';

    item.seoWords = item.name + '^' + item.firstGuest + '^' + item.firstGuestDuty;
    
    item.m_filterTag = item.m_program + '$' + item.m_track;

    // item.m_filterTag = '';
    // if(item.m_programtrack.length == 2){
    //     item.m_filterTag = item.m_programtrack[0] + '$' + item.m_programtrack[1];
    // }

    // if(item.category){
    //     item.categoryArr = item.category[1].nodes;
    // }else{
    //     item.categoryArr = [];
    // }

    if(!item.i_liveurl){
        item.i_liveurl = '';
    }

    if(!item.m_vhallLiveId){
        item.m_vhallLiveId = '';
    }else{
        item.m_vhallLiveId = trim(item.m_vhallLiveId);
        if(!isNumber(item.m_vhallLiveId)){
            item.m_vhallLiveId = '';
        }
    }

    

    item.filesId = filesArr.join('|');
    item.filesIdArr = filesArr;

    return item;
}

function numToZh(num){
    let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
    　　let strArr = temp.toString().split("").reverse();
    　　let newNum = "";
    　　for (var i = 0; i < strArr.length; i++) {
    　　newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
    　　}
        　 return newNum;
    }
    let res = getWan(num);
    if(num > 9 && num < 20){
        res = res.substr(1, 2);
    }
    return res;
}

/**
 * 剥离html标签
 * @method stripHtmlTags
 * @param {html} 富文本
 */
 export function stripHtmlTags(html) {
    let str = html.replace(/<\/?.+?>/g, "");
    return str.replace(/ /g, "");
}

/**
 * 获取用户sess
 */
 export function getUserSess() {
    let smarket_sess = Cookies.get("SMARKET_MEMBER_SESS");
    let register_info = false;
    if(Cookies.get("registerInfo_" + config.schemaId)){
        register_info = JSON.parse(Cookies.get("registerInfo_" + config.schemaId));
    }
    let sess = '';
    
    if(smarket_sess){
        sess = smarket_sess;
    }else if(register_info && register_info.session){
        sess = register_info.session;
    }

    return sess;

    // if(Cookies.get("SMARKET_MEMBER_SESS")){
    //     return Cookies.get("SMARKET_MEMBER_SESS");
    // }else{
    //     // return '865abdd01edc26db1dd4d9d58dd76ea3';
    //     return '';
    // }
}

/**
 * 跳转报名
 */
 export function goSignup(type, shareKey, redirectType=false, isInter=0) {

    if(type == 'offline' && store.state.relationId == 7 && store.state.orderOnline == 1){
        return;
    }

    let status = '';
    if(!store.state.isLogin){
        status = type == 'online' ? 'login' : 'home';
    }else{
        if(type == 'online'){
            if(isInter == 1){
                status = 'login';
            }else{
                if(store.state.orderOnline == 0){
                    // 未预约
                    // status = 'order';
                    status = 'login';
                }else if(store.state.orderOnline == 1){
                    // 已预约
                    status = 'orderSuccess';
                }else{
                    // 审核中
                    status = 'orderSuccess';
                }

                if(store.state.silentFail){
                    status = 'order';
                }
            }
        }else{
            if(store.state.orderOffline == 0){
                // 未预约
                // status = 'sign';
                // status = 'home';
                if(store.state.orderOnline == 1){
                    status = 'sign';
                }else{
                    status = 'home';
                }
            }else if(store.state.orderOffline == 1){
                // 已预约
                status = 'success';
            }else{
                // 审核中
                status = 'success';
            }
        }
    }

    // let shareKey = '';

    let params = {
        meetingType: type,
        relationId: store.state.relationId,
        shareKey: shareKey ? shareKey : '',
        // returnUrl: encodeURIComponent(window.location.href.split('?')[0]),
        returnUrl: isInter == 1 ? encodeURIComponent(window.location.href) : '',
        tc: getTc(),
        isinter: isInter,
    };

    let url = config.url.signup + status + '?' + objectToString(params);


    if(redirectType){
        window.location.href = url;
    }else{
        window.open(url);
    }

}

export function replaceCdnUrl(str){
    if(typeof(str) != 'string') return '';
    else return str.replace('hwyhw.smarket.net.cn', 'hwyhw-files.smarket.net.cn');
    // else return process.env.VUE_APP_FLAG === 'pro' ? str.replace('hwyhw.smarket.net.cn', 'hwyhw-files.smarket.net.cn') : str;
}

/** * pdf预览 */
export function previewFile(url){
    window.open(window.$config.previewUrl + url);
}

/** * 参会指南数据处理 */
export function guideDataCook(res){
    let data = {
        fangyi: [],
        banche: [],
        jiaotong: [],
        canting: []
    };
    if(res.result == 0){
        res.content.items = sortKey(res.content.items, 'order');
        res.content.items.map(item=>{
            if(item.isRecommend == 1 && item.isTop == 1){
                data.fangyi = item.summary.split('{br}');
            }else if(item.isRecommend == 0 && item.isTop == 1){
                let obj = false;
                try{
                    obj = JSON.parse('{' + item.summary + '}');
                }catch(e){

                }
                if(obj){
                    data.banche.push(obj);
                }
            }
            else if(item.isRecommend == 1 && item.isTop == 0){
                let obj = false;
                try{
                    obj = JSON.parse('{' + item.summary + '}');
                }catch(e){

                }
                if(obj){
                    obj.img = replaceCdnUrl(item.coverImageRealPath);
                    data.jiaotong.push(obj);
                }
            }else if(item.isRecommend == 0 && item.isTop == 0){
                let obj = false;
                try{
                    obj = JSON.parse('{' + item.summary + '}');
                }catch(e){

                }
                if(obj){
                    obj.img = replaceCdnUrl(item.coverImageRealPath);
                    data.canting.push(obj);
                }
            }
        });
    }

    return data;
}

export function getTc(){
    let tc = config.signUpTcCode;
    if(localStorage.getItem('eco_2021_agenda_tc')){
        tc = localStorage.getItem('eco_2021_agenda_tc');
    }
    if(tc == 'undefined'){
        tc = '';
    }
    return tc;
}

export function getShareKey(){
    let shareKey = '';
    if(localStorage.getItem('eco_2021_agenda_shareKey')){
        shareKey = localStorage.getItem('eco_2021_agenda_shareKey');
    }
    if(shareKey == 'undefined'){
        shareKey = '';
    }
    return shareKey;
}

// 校验是否数字
function isNumber(val){

    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)){
        return true;
    }else{
        return false;
    }

}

export function goVhall(vhallId, isEco=false){
    if(!vhallId){
        return;
    }else if(!isNumber(vhallId)){
        return;
    }else{
        let url = window.$config.url.vhall + vhallId + '.html';

        if(isEco){
            url = url.replace('meeting', 'live');
        }
        
        if(store.state.userLogin && store.state.myData.phone){
            url += '?unique=' + md5(store.state.myData.phone);
        }
        
        // window.location.href = url;
        window.open(url);
    }
}
   
function trim(str){
    return str.replace(/(^\s*)|(\s*$)/g, "");
}